import {getDisasterByArea, getAllDisaster} from '../../../api/eastCoastMonitorApi/disasterApi'
import Utils from '../../../utils/utils'
import CONST from '../../../utils/const'

const state = {
  allDisasterInTime: [],
  areaDisasterInTime: []
}

const getters = {
  getAllDisaster() {
    return state.allDisasterInTime
  },
  
  getDisaster(){
    return state.areaDisasterInTime
  }
}

const actions = {
  async getAllDisaster({ commit }, condition = {}) {
    const result = await getAllDisaster(condition)

    if(result.success){
      commit('allDisasterInTime', result.data)
    }
  },

  async getAreaDisaster({ commit }, condition = {}) {
    const result = await getDisasterByArea(condition)

    if(result.success){
      commit('areaDisasterInTime', result.data)
    }
  }
}

const mutations = {
  allDisasterInTime(state, data) {
    state.allDisasterInTime = data
  },

  areaDisasterInTime(state, data) {
    state.areaDisasterInTime = data
  }
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}